import axios from "axios";
export default {
  state: {
    objetoUsuario: {},
    permissoesUsuario: {},
    permitirSalvamento: false
  },
  actions: {
    async getInformacaoUsuario({ dispatch }) {
      return axios.get(
        await dispatch("CriarUrl", {
          resource: `usuario/info`
        })
      );
    },
    async getPermissoesUsuario({ dispatch }) {
      return axios.get(
        await dispatch("CriarUrl", {
          resource: `usuario/permissoes`
        })
      );
    }
  },
  mutations: {
    setUsuarioCompleto(state, _objetoUsuario) {
      if (Object.keys(_objetoUsuario).length === 0) return;

      localStorage.setItem("objetoUsuarioRNP", JSON.stringify(_objetoUsuario));
      state.objetoUsuario = _objetoUsuario;
    },
    deleteUsuario() {
      localStorage.removeItem("objetoUsuarioRNP");
    },
    setUsuarioPermissoes(state, _permissoes) {
      if (Object.keys(_permissoes).length === 0) return;
      localStorage.setItem("permissoesUsuarioRNP", JSON.stringify(_permissoes));
      state.permissoesUsuario = _permissoes;
    },
    deletePermissoes() {
      localStorage.removeItem("permissoesUsuarioRNP");
    },
    recuperarDadosUsuario(state) {
      let objetoUsuario = JSON.parse(localStorage.getItem("objetoUsuarioRNP"));
      let permissoesUsuario = JSON.parse(
        localStorage.getItem("permissoesUsuarioRNP")
      );

      // console.log(permissoesUsuario.telas);

      // tweak para fase sem suporte do back
      // permissoesUsuario.telas.push("RELATORIO_PRODUTIVIDADE");

      if (!objetoUsuario) return;

      if (
        [null, undefined].includes(objetoUsuario) &&
        Object.keys(objetoUsuario).length === 0
      ) {
        return;
      }

      state.objetoUsuario = objetoUsuario;

      state.permissoesUsuario = permissoesUsuario;

      if (
        objetoUsuario.papel.chave !== "ADM_RECURS_PROPRIO" &&
        objetoUsuario.papel.chave !== "SINGULAR" &&
        objetoUsuario.papel.chave !== "ADMINISTRADOR"
      ) {
        state.permitirSalvamento = false;
      } else {
        state.permitirSalvamento = true;
      }
    },
    setPermitirSalvamento(state, _boo) {
      state.permitirSalvamento = _boo;
    }
  },
  getters: {
    getObjetoUsuario: state => state.objetoUsuario,
    getPermissoesUsuario: state => state.permissoesUsuario,
    getPermitirSalvamento: state => state.permitirSalvamento
  }
};
